import React, { Component } from "react";
// import PropTypes from "prop-types";
import { FaGithub } from 'react-icons/fa';
import Button from "react-bootstrap/Button";

import ProjectsGrid from "../../components/projectsGrid/ProjectsGrid";
import "./Projects.scss";
export class Projects extends Component {
    static propTypes = {};

    render() {
        return (
            <div className="project-container d-flex flex-column justify-content-center align-items-center text-center">
                <h1 className="project-header">MY PROJECTS</h1>
                <Button
                    href="https://github.com/SahanAmarsha"
                    target={"_blank"}
                    variant="dark"
                    className={"github-button d-flex flex-row justify-content-center"}
                >
                    <p className="text-center align-self-center mr-5 github-text">View My Github</p>
                    <FaGithub className="github-icon"/>
                </Button>
                <ProjectsGrid/>
            </div>
        );
    }
}

export default Projects;
